export default __webpack_public_path__ + "static/media/m-btn-check-active.0107f8af.svg";